import {Component} from './component';

export class PdfPreview extends Component {

    /** @type {HTMLElement} */
    container;
    /** @type {HTMLElement} */
    body;
    /** @type {HTMLIFrameElement} */
    frame;
    /** @type {HTMLAnchorElement} */
    download;
    /** @type {HTMLElement} */
    title;
    /** @type {boolean} */
    open;
    /** @type {HTMLElement|null} */
    trigger;
    /** @type {string} */
    prevOverflow;

    setup() {
        this.container = this.$el;
        this.body = this.$refs.body;
        this.frame = /** @type {HTMLIFrameElement} */ (this.$refs.frame);
        this.download = /** @type {HTMLAnchorElement} */ (this.$refs.download);
        this.title = this.$refs.title;
        this.open = false;
        this.trigger = null;

        const content = document.querySelector('.page-content');
        if (content) {
            for (const marker of content.querySelectorAll('a.pdf-embed-marker[data-pdf-embed="inline"]')) {
                this.upgradeMarker(marker);
            }
            content.addEventListener('click', event => this.onContentClick(event));
        }
    }

    /**
     * @param {HTMLAnchorElement} marker
     */
    upgradeMarker(marker) {
        const wrapper = document.createElement('div');
        wrapper.className = 'pdf-inline-embed';
        const href = marker.getAttribute('href');
        const title = marker.textContent.trim();

        const iframe = document.createElement('iframe');
        iframe.src = `${href}?open=true`;
        iframe.title = title;
        iframe.loading = 'lazy';

        const download = document.createElement('a');
        download.href = href;
        download.textContent = title;
        download.target = '_blank';
        download.rel = 'noopener';

        wrapper.append(iframe, download);
        marker.replaceWith(wrapper);
    }

    /**
     * @param {MouseEvent} event
     */
    onContentClick(event) {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        const link = event.target.closest('a');
        if (!link) {
            return;
        }

        if (link.closest('.pdf-inline-embed')) {
            return;
        }

        const url = new URL(link.href, window.location.href);
        const basePath = this.getBasePath();
        const relativePath = url.pathname.slice(url.pathname.startsWith(basePath) ? basePath.length : 0);
        if (url.origin !== window.location.origin || !/^\/attachments\/\d+$/.test(relativePath)) {
            return;
        }

        event.preventDefault();
        this.checkAndOpen(url, link);
    }

    getBasePath() {
        const path = new URL(document.querySelector('meta[name="base-url"]')?.getAttribute('content') || '', window.location.href).pathname;
        return path === '/' ? '' : path;
    }

    /**
     * @param {URL} url
     * @param {HTMLAnchorElement} link
     */
    async checkAndOpen(url, link) {
        const requestId = this.requestId = (this.requestId || 0) + 1;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 5000);

        try {
            const response = await fetch(`${url.pathname}?open=true`, {
                method: 'HEAD',
                signal: controller.signal,
            });
            const contentType = response.headers.get('Content-Type') || '';
            if (requestId === this.requestId && response.ok && contentType.includes('application/pdf')) {
                this.showPdf(`${url.pathname}?open=true`, url.pathname, link.textContent.trim(), link);
                return;
            }
        } catch {
            // Fall through to default link behaviour
        } finally {
            clearTimeout(timer);
        }

        if (requestId === this.requestId) this.followLink(url.href);
    }

    /**
     * @param {string} frameSrc
     * @param {string} downloadHref
     * @param {string} title
     * @param {HTMLElement|null} trigger
     */
    showPdf(frameSrc, downloadHref, title, trigger) {
        this.frame.src = frameSrc;
        this.download.href = downloadHref;
        this.title.textContent = title;
        this.trigger = trigger;

        if (this.open) {
            this.body.focus();
            return;
        }

        this.open = true;
        this.prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.getPopup().show(null, () => this.onClosed());
        this.body.focus();
    }

    onClosed() {
        this.frame.src = 'about:blank';
        document.body.style.overflow = this.prevOverflow;
        this.open = false;
        if (this.trigger) {
            this.trigger.focus();
        }
    }

    getPopup() {
        return window.$components.firstOnElement(this.$el, 'popup');
    }

    /**
     * @param {string} href
     */
    followLink(href) {
        window.location.href = href;
    }

}
